module.exports = __webpack_public_path__ + "media/stylesheets/opensansi700-947cdeffd6fcc0d7b2354465134c972c.woff";